import React from 'react';
import { connect } from 'react-redux';
//import TranslatedLink from './TranslatedLinkLeague.jsx';
import TranslatedLink from './TranslatedLink.jsx';
import getArticleLink from '../util/getArticleLink';

const mapStateToProps = state =>({
  country: state.country,
});

@connect(mapStateToProps)
export default class ArticleLink extends React.PureComponent {
  render() {
    const { country, contentContainer, ...otherProps } = this.props;
    const articleLink = getArticleLink(contentContainer, { country: country });

    return (
      <TranslatedLink name={articleLink.linkType} routeParams={articleLink.routeParams} {...otherProps}>
        {this.props.children}
      </TranslatedLink>
    );
  }
}

ArticleLink.propTypes = {
  contentContainer: React.PropTypes.object.isRequired,
  country: React.PropTypes.string,
  children: React.PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/component/ArticleLink.jsx